import React from 'react';
import { BrowserRouter as Router, Routes, Route } from 'react-router-dom';
import { HelmetProvider } from 'react-helmet-async';
import { LanguageProvider } from './i18n';
import Header from './components/Header';
import HomePage from './pages/HomePage';
import BookingPage from './pages/BookingPage';
import TherapistListPage from './pages/TherapistListPage';
import ConfirmationPage from './pages/ConfirmationPage';
import NotFoundPage from './pages/NotFoundPage';
import ProtectedRoute from './components/admin/ProtectedRoute';
import AdminLoginPage from './pages/admin/AdminLoginPage';
import DashboardPage from './pages/admin/DashboardPage';
import BookingListPage from './pages/admin/BookingListPage';
import BookingDetailPage from './pages/admin/BookingDetailPage';
import PaymentListPage from './pages/admin/PaymentListPage';
import AdminTherapistListPage from './pages/admin/TherapistListPage';
import TherapistFormPage from './pages/admin/TherapistFormPage';
import UserListPage from './pages/admin/UserListPage';
import UserFormPage from './pages/admin/UserFormPage';
import './App.css';

function App() {
  return (
    <HelmetProvider>
    <LanguageProvider>
      <Router>
        <div className="App">
          <Routes>
            {/* Public Routes */}
            <Route path="/" element={<><Header /><HomePage /></>} />
            <Route path="/booking" element={<><Header /><BookingPage /></>} />
            <Route path="/therapists" element={<><Header /><TherapistListPage /></>} />
            <Route path="/confirmation" element={<><Header /><ConfirmationPage /></>} />

            {/* Admin Routes */}
            <Route path="/admin/login" element={<AdminLoginPage />} />
            <Route path="/admin" element={<ProtectedRoute><DashboardPage /></ProtectedRoute>} />
            <Route path="/admin/bookings" element={<ProtectedRoute><BookingListPage /></ProtectedRoute>} />
            <Route path="/admin/bookings/:id" element={<ProtectedRoute><BookingDetailPage /></ProtectedRoute>} />
            <Route path="/admin/payments" element={<ProtectedRoute><PaymentListPage /></ProtectedRoute>} />
            <Route path="/admin/therapists" element={<ProtectedRoute><AdminTherapistListPage /></ProtectedRoute>} />
            <Route path="/admin/therapists/new" element={<ProtectedRoute><TherapistFormPage /></ProtectedRoute>} />
            <Route path="/admin/therapists/:id" element={<ProtectedRoute><TherapistFormPage /></ProtectedRoute>} />
            <Route path="/admin/users" element={<ProtectedRoute requireSuperMaster><UserListPage /></ProtectedRoute>} />
            <Route path="/admin/users/new" element={<ProtectedRoute requireSuperMaster><UserFormPage /></ProtectedRoute>} />
            <Route path="/admin/users/:id" element={<ProtectedRoute requireSuperMaster><UserFormPage /></ProtectedRoute>} />

            {/* 404 */}
            <Route path="*" element={<><Header /><NotFoundPage /></>} />
          </Routes>
        </div>
      </Router>
    </LanguageProvider>
    </HelmetProvider>
  );
}

export default App;
